import React, { Component, Suspense } from 'react';
import axios from 'axios';
import {
  Button,
  Col,
  Row,
  Input,
} from 'reactstrap';
import Page404Image from '../../../assets/img/404.png';
import '../../../scss/minbodyheight.scss';
// import './blogs.scss'
var sectionStyle = {
  width: "100%"
};

class ProductPage404 extends Component {
  constructor(props) {
    super(props);
    this.enableLoader = this.enableLoader.bind(this);

    this.state = {
      width: window.innerWidth,
    };
  }
  enableLoader() {
    document.body.style.background = '#ffffff';
  }
  loading = () => <div className="animated fadeIn pt-1 text-center">Loading...</div>
  render() {
    const { width } = this.state;
    const isMobile = width < 980;
    if (isMobile) {
      return (
        <Suspense fallback={this.loading()} >
          <Row className="pt-5 mt-5">
            <Col xs="12" lg="6" md="6" className="">
              <img src={Page404Image} className="w-100" />
            </Col>
            <Col xs="12" lg="6" md="6" className="float-left mb-3 p-0" >
              <Col xs="12" lg="12" md="12" className="text-center">
                <h1 className="blue-color col-12 bold font-3">Webnos</h1>
                <h6 className="col-12 blue-color col-12 bold font-2" > has wiped off 50% pages from the world
                </h6>
                <h6 className="col-12"> We have saved a few pages especially for you. Please take a look! </h6>
                <br/>
                <Col xs="12" lg="12" md="12">
                  <Button href="/product-thinking" active block color="info" aria-pressed="true" className={`notify-button bold`} >Our Trainings<i className="fa fa-arrow-right float-right mt-1"></i></Button>
                  <Button href="/product-thinking/product-management" active block color="info" aria-pressed="true" className={`notify-button bold`} >Videos<i className="fa fa-arrow-right float-right mt-1"></i></Button>
                  <Button href="/product-thinking" active block color="info" aria-pressed="true" className={`notify-button bold`} >Blogs<i className="fa fa-arrow-right float-right mt-1"></i></Button>
                  <Button href="/product-thinking-about-us" active block color="info" aria-pressed="true" className={`notify-button bold`} >About Us<i className="fa fa-arrow-right float-right mt-1"></i></Button>
                </Col>
              </Col>
            </Col>
          </Row>
        </Suspense>
      );
    }else{

      return (
        <Row>
          <Col xs="12" lg="10" md="10" className="center inline-flex pt-5 mt-7" >
            <Col xs="12" lg="6" md="6" className="p-4 float-left">
              <img src={Page404Image} className="w-100" />
            </Col>
            <Col xs="12" lg="6" md="6" className="p-4 float-left align-item-center" >
              <Col xs="12" lg="12" md="12">
                <h1 className="blue-color col-12 bold font-5">Webnos</h1>
                <h6 className="col-12 blue-color col-12 bold font-2" > has wiped off 50% pages from the world
                </h6>
                <h6 className="col-12"> We have saved a few pages especially for you. Please take a look! </h6>
                <br/>
                <Col xs="12" lg="12" md="12">
                  <Button href="/product-thinking" active block color="info" aria-pressed="true" className={`notify-button bold`} >Our Trainings<i className="fa fa-arrow-right float-right mt-1"></i></Button>
                  <Button href="/product-thinking/product-management" active block color="info" aria-pressed="true" className={`notify-button bold`} >Videos<i className="fa fa-arrow-right float-right mt-1"></i></Button>
                  <Button href="/product-thinking" active block color="info" aria-pressed="true" className={`notify-button bold`} >Blogs<i className="fa fa-arrow-right float-right mt-1"></i></Button>
                  <Button href="/product-thinking-about-us" active block color="info" aria-pressed="true" className={`notify-button bold`} >About Us<i className="fa fa-arrow-right float-right mt-1"></i></Button>
                </Col>
              </Col>
            </Col>
          </Col>
        </Row>
      );
    }
  }
}


export default ProductPage404;
